"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  bg: 'transparent',
  boxShadow: 'none',
  borderRadius: 12,
  cursor: 'initial',
  bgActive: 'initial',
  bgHover: 'initial'
};
const primary = { ...common,
  bg: 'background.default',
  boxShadow: [0, 0, 0, 1, 'ui4', true]
};
const secondary = { ...common
};
const interactive1 = { ...common,
  bg: 'background.default',
  bgActive: 'interactive.ui.active',
  bgHover: 'interactive.ui.hover',
  boxShadow: [0, 0, 0, 1, 'ui4'],
  cursor: 'pointer'
};
const interactive2 = { ...common,
  bg: 'background.default',
  bgActive: 'interactive.ui.active',
  bgHover: 'interactive.ui.hover',
  borderRadius: 'none',
  cursor: 'pointer'
};
const interactive3 = { ...common,
  bg: 'background.tan',
  bgActive: 'interactive.tan.active',
  bgHover: 'interactive.tan.hover',
  cursor: 'pointer'
};
const theme = {
  primary,
  secondary,
  interactive1,
  interactive2,
  interactive3
};
exports.theme = theme;
//# sourceMappingURL=Card.theme.js.map